export const transportManagerMenus = () => ({
    id: `main-menu-2-all`,
    path: '/management/logistics/transport/transporters',
    label: 'Transport Manager',
    Description: 'Transport Manager is a comprehensive solution that centralizes customer, sales, and agent management, providing a unified platform for efficient and streamlined operations.',
    isEnabled: true,
    svg: (
        <svg className="h-6 w-6 fill-current mr-2" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path fill="#ffffff" d="M16 3H8a1 1 0 0 0-1 1v2H3v2h1v11a1 1 0 0 0 1 1h1a3 3 0 0 0 6 0h4a3 3 0 0 0 6 0h1a1 1 0 0 0 1-1V8h1V6h-4V4a1 1 0 0 0-1-1zm-7 15a1 1 0 1 1-2 0 1 1 0 0 1 2 0zm10 0a1 1 0 1 1-2 0 1 1 0 0 1 2 0zm1-4H5V9h14v5zm-2-7H7V5h10v2z" />
        </svg>

    ),

    subMenu: [
        {
            id: `coln-1-collections`,
            label: 'Partner',
            svg: (
                <svg className="h-6 w-6 fill-current mr-2" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                    <path fill="#007BFF" d="M12 2a5 5 0 1 0 0 10 5 5 0 0 0 0-10zm-7 9h1a6 6 0 1 1 12 0h1a7 7 0 0 1-7 7 7 7 0 0 1-7-7z" />
                    <path fill="#007BFF" d="M6 14a4 4 0 0 0 4 4h4a4 4 0 0 0 4-4h2a6 6 0 0 1-6 6H8a6 6 0 0 1-6-6h2z" />
                </svg>

            ),
            path: '/management/partners',
            isEnabled: true,

        },
        {
            id: `coln-1-collections`,
            label: 'Transporter',
            svg: (
                <svg className="h-6 w-6 fill-current mr-2" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                    <path fill="#007BFF" d="M3 5h18a1 1 0 0 1 1 1v12a1 1 0 0 1-1 1H3a1 1 0 0 1-1-1V6a1 1 0 0 1 1-1zm1 2v10h16V7H4zm2 12h2a1 1 0 1 1 0 2H6a1 1 0 1 1 0-2zm10 0h2a1 1 0 1 1 0 2h-2a1 1 0 1 1 0-2z" />
                </svg>
            ),
            path: '/management/logistics/transport/transporters',
            isEnabled: true,

        },
        {
            id: `coln-1-collections`,
            label: 'Agent',
            svg: (
                <svg className="h-6 w-6 fill-current mr-2" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                    <path fill="#007BFF" d="M12 12c2.21 0 4-1.79 4-4s-1.79-4-4-4-4 1.79-4 4 1.79 4 4 4zm0 2c-2.67 0-8 1.34-8 4v2h16v-2c0-2.66-5.33-4-8-4z" />
                </svg>

            ),
            path: '/management/logistics/transport/transport-agents',
            isEnabled: true,

        },
        {
            id: `coln-1-collections`,
            label: 'Vehicle categories',
            svg: (
                <svg className="h-6 w-6 fill-current mr-2" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                    <path fill="#007BFF" d="M5 16H4a1 1 0 0 0-1 1v1a1 1 0 0 0 1 1h1a1 1 0 0 0 1-1v-1a1 1 0 0 0-1-1zM19 16h-1a1 1 0 0 0-1 1v1a1 1 0 0 0 1 1h1a1 1 0 0 0 1-1v-1a1 1 0 0 0-1-1zM12 3a5 5 0 0 0-5 5v3H5a1 1 0 0 0-1 1v5a1 1 0 0 0 1 1h1v1a1 1 0 0 0 1 1h12a1 1 0 0 0 1-1v-1h1a1 1 0 0 0 1-1v-5a1 1 0 0 0-1-1h-2V8a5 5 0 0 0-5-5z" />
                </svg>

            ),
            path: '/management/logistics/transport/vehicle-categories',
            isEnabled: true,

        },
        {
            id: `coln-1-collections`,
            label: 'Vehicles',
            svg: (
                <svg className="h-6 w-6 fill-current mr-2" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                    <path fill="#007BFF" d="M5 16H4a1 1 0 0 0-1 1v1a1 1 0 0 0 1 1h1a1 1 0 0 0 1-1v-1a1 1 0 0 0-1-1zM19 16h-1a1 1 0 0 0-1 1v1a1 1 0 0 0 1 1h1a1 1 0 0 0 1-1v-1a1 1 0 0 0-1-1zM12 3a5 5 0 0 0-5 5v3H5a1 1 0 0 0-1 1v5a1 1 0 0 0 1 1h1v1a1 1 0 0 0 1 1h12a1 1 0 0 0 1-1v-1h1a1 1 0 0 0 1-1v-5a1 1 0 0 0-1-1h-2V8a5 5 0 0 0-5-5z" />
                </svg>

            ),
            path: '/management/logistics/transport/vehicle-registations',
            isEnabled: true,

        },
        {
            id: `coln-1-collections`,
            label: 'Package Constrains',
            svg: (
                <svg className="h-6 w-6 fill-current mr-2" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                    <path fill="#007BFF" d="M5 16H4a1 1 0 0 0-1 1v1a1 1 0 0 0 1 1h1a1 1 0 0 0 1-1v-1a1 1 0 0 0-1-1zM19 16h-1a1 1 0 0 0-1 1v1a1 1 0 0 0 1 1h1a1 1 0 0 0 1-1v-1a1 1 0 0 0-1-1zM12 3a5 5 0 0 0-5 5v3H5a1 1 0 0 0-1 1v5a1 1 0 0 0 1 1h1v1a1 1 0 0 0 1 1h12a1 1 0 0 0 1-1v-1h1a1 1 0 0 0 1-1v-5a1 1 0 0 0-1-1h-2V8a5 5 0 0 0-5-5z" />
                </svg>

            ),
            path: '/management/logistics/transport/vehicle-registations',
            isEnabled: true,

        },
        {
            id: `coln-1-collections`,
            label: 'Slots',
            svg: (
                <svg className="h-6 w-6 fill-current mr-2" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                    <path fill="#007BFF" d="M5 16H4a1 1 0 0 0-1 1v1a1 1 0 0 0 1 1h1a1 1 0 0 0 1-1v-1a1 1 0 0 0-1-1zM19 16h-1a1 1 0 0 0-1 1v1a1 1 0 0 0 1 1h1a1 1 0 0 0 1-1v-1a1 1 0 0 0-1-1zM12 3a5 5 0 0 0-5 5v3H5a1 1 0 0 0-1 1v5a1 1 0 0 0 1 1h1v1a1 1 0 0 0 1 1h12a1 1 0 0 0 1-1v-1h1a1 1 0 0 0 1-1v-5a1 1 0 0 0-1-1h-2V8a5 5 0 0 0-5-5z" />
                </svg>

            ),
            path: '/management/logistics/transport/vehicle-registations',
            isEnabled: true,

        },

    ],
}
)
